import React from 'react';

const AsyncWebsiteGardenPage = React.lazy(() => import('../List/WebsiteGardenContainer'));

export const WebsiteGardenPage = () => {
  return <AsyncWebsiteGardenPage />;
};
